import styled from 'styled-components';

export const Title = styled.h2`
  color: ${props => props.theme.palette.text.main};
  font-size: ${props => props.theme.typography.sizes.title2};
`;
